import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ResetPasswordPage } from '@/features/auth';

/** Public. `token` comes from the e-mailed link; the page keeps it in memory and strips it from the URL. */
export const Route = createFileRoute('/reset-password')({
  validateSearch: z.object({ token: z.string().max(200).optional() }),
  component: function ResetPassword() {
    const { token } = Route.useSearch();
    return <ResetPasswordPage token={token} />;
  },
});
